<template>
    <div class="d-callout" :class="[_variant, { 'd-callout-outline': outline }]" role="callout" :id="id">
        <div class="d-callout-title"><slot name="title"></slot></div>
        <div>
            <slot></slot>       
        </div>
    </div>
</template>

<script setup>

import { computed, defineProps, toRefs } from 'vue'

// PROPS
const props = defineProps({
    variant: { type: String, default: "primary" },    
    outline: Boolean
})
const { variant } = toRefs(props);
const id = (Math.random() * 100000) + '_callout';

// computed
const _variant = computed(() => "d-callout-" + (variant.value ?? "primary"))

</script>
